import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUmbracoComponent } from './simple-icons-umbraco.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUmbracoComponent ],
    exports:      [ SimpleIconsUmbracoComponent ],
    bootstrap:    []
})
export class SimpleIconsUmbracoModule {}
